/***********************************************************************************************************************
 * CAS Protected Services, which has a unique policy type
 * For CAS non-provision usage
 * A service has a unique policy_type, while a service may have multiple apps to provision(but a app may not be associated with a service), each app has multiple tokens
 * Service type is deprecated due to it is not unique for a service
 ***********************************************************************************************************************
 */
// CAS protect service, tm_company_plan
export enum Service {
  Exchange = 'exchange',
  OneDrive = 'oneDrive',
  SharePoint = 'sharePoint',
  Box = 'box',
  Dropbox = 'dropbox',
  GoogleDrive = 'googleDrive',
  SalesforceSandbox = 'salesforceSandbox', // deprecated
  SalesforceProduction = 'salesforceProduction', // deprecated
  Gmail = 'gmail',
  IdentityProtection = 'identityProtection',
  Teams = 'teams',
  TeamsChat = 'teamsChat',
  Mip = 'mip',
  ExchangeServer = 'exchangeServer', // hybrid smex, no policy
  ExchangeInline = 'exchangeInline',
  GmailInline = 'gmailInline',
}

// CAS protect service's policy, come from tm_policy
export enum PolicyType {
  Exchange = 1,
  SharePoint = 2,
  OneDrive = 3,
  Box = 4,
  Dropbox = 5,
  GoogleDrive = 6,
  SalesforceSandbox = 9, // deprecated
  SalesforceProduction = 10, // deprecated
  Gmail = 21,
  GmailInline = 22,
  Teams = 41,
  TeamsChat = 42,
  ExchangeInline = 82,
}

// exchange server, mip, identity protection do not have policy
export const PolicyType2Service: { [key in PolicyType]: Service } = {
  [PolicyType.Exchange]: Service.Exchange,
  [PolicyType.SharePoint]: Service.SharePoint,
  [PolicyType.OneDrive]: Service.OneDrive,
  [PolicyType.Box]: Service.Box,
  [PolicyType.Dropbox]: Service.Dropbox,
  [PolicyType.GoogleDrive]: Service.GoogleDrive,
  [PolicyType.SalesforceSandbox]: Service.SalesforceSandbox, // deprecated
  [PolicyType.SalesforceProduction]: Service.SalesforceProduction, // deprecated
  [PolicyType.Gmail]: Service.Gmail,
  [PolicyType.GmailInline]: Service.GmailInline,
  [PolicyType.Teams]: Service.Teams,
  [PolicyType.TeamsChat]: Service.TeamsChat,
  [PolicyType.ExchangeInline]: Service.ExchangeInline,
};

/***********************************************************************************************************************
 * For CAS Service Account(tm_delegator_account)
 * Each CAS provisioned App has a unique service account(delegator account)
 ***********************************************************************************************************************
 */
// Cas Provision Apps, come from tm_delegator_account
export enum App {
  Exchange = 'exchange',
  DeprecatedSharePointOneDrive = 'deprecatedSpod', // No token mode, will be deprecated after migration
  Box = 'box',
  Dropbox = 'dropbox',
  GoogleDrive = 'googleDrive',
  Rms = 'rms',
  AnomalyDetection = 'anomalyDetection', // deprecated
  SharePoint = 'sharePoint', // sharepoint main app
  SharePointBasic = 'sharePointBasic', // sharepoint second app, used for sharepoint basic token
  OneDrive = 'oneDrive', // onedrive main app
  OneDriveBasic = 'oneDriveBasic', // onedrive second app, used for onedrive basic token
  Gmail = 'gmail',
  GmailInline = 'gmailInline',
  Mitigation = 'mitigation',
  Soc = 'soc',
  SocManagement = 'socManagement',
  IdentityProtection = 'identityProtection',
  O365AuditLog = 'o365AuditLog',
  Teams = 'teams', // teams main app
  TeamsBasic = 'teamsBasic', // teams second app
  TeamsChat = 'teamsChat',
  Mip = 'mip',
  ExchangeServer = 'exchangeServer',
  ExchangeMailFlow = 'exchangeMailFlow', // deprecated
  ExchangeInline = 'exchangeInline', // exchange inline main app
  ExchangeInlineMailFlow = 'exchangeInlineMailFlow', // exchange inline second app
  GraphNotification = 'graphNotification', // only used for CAS internal send notification
  SalesforceSandbox = 'salesforceSandbox', // deprecated
  SalesforceProduction = 'salesforceProduction', // deprecated
}

// Cas provision app's type, come from tm_delegator_account
export enum AppType {
  Exchange = 1,
  DeprecatedSharePointOneDrive = 4, // No token mode, will be deprecated after migration
  Box = 5,
  Dropbox = 6,
  GoogleDrive = 7,
  Rms = 9, // deprecated
  SalesforceSandbox = 10, // deprecated
  SalesforceProduction = 11, // deprecated
  AnomalyDetection = 12, // deprecated
  SharePoint = 15, // sharepoint main app
  OneDrive, // onedrive main app
  SharePointBasic, // sharepoint second app, used for sharepoint basic token
  OneDriveBasic, // onedrive second app, used for onedrive basic token
  Gmail = 21,
  GmailInline = 22,
  Mitigation = 31,
  Soc = 32,
  SocManagement = 33,
  IdentityProtection = 35,
  O365AuditLog = 36,
  Teams = 41, // teams main app
  TeamsChat = 42,
  Mip = 46,
  TeamsBasic = 47, // teams second app
  ExchangeServer = 51,
  ExchangeMailFlow = 81, // deprecated
  ExchangeInline = 82, // exchange inline mail app
  ExchangeInlineMailFlow = 83, // exchange inline second app
  GraphNotification = 111, // only used for CAS internal send notification
}

// CAS App name to delegator account type
export const App2AppType: { [key in App]: AppType } = {
  [App.Exchange]: AppType.Exchange,
  [App.DeprecatedSharePointOneDrive]: AppType.DeprecatedSharePointOneDrive,
  [App.Box]: AppType.Box,
  [App.Dropbox]: AppType.Dropbox,
  [App.GoogleDrive]: AppType.GoogleDrive,
  [App.Rms]: AppType.Rms,
  [App.SalesforceSandbox]: AppType.SalesforceSandbox, // deprecated
  [App.SalesforceProduction]: AppType.SalesforceProduction, // deprecated
  [App.AnomalyDetection]: AppType.AnomalyDetection, // deprecated
  [App.SharePoint]: AppType.SharePoint, // sharepoint main app
  [App.SharePointBasic]: AppType.SharePointBasic, // sharepoint second app, used for sharepoint basic token
  [App.OneDrive]: AppType.OneDrive, // onedrive main app
  [App.OneDriveBasic]: AppType.OneDriveBasic, // onedrive second app, used for onedrive basic token
  [App.Gmail]: AppType.Gmail,
  [App.GmailInline]: AppType.GmailInline,
  [App.Mitigation]: AppType.Mitigation,
  [App.Soc]: AppType.Soc,
  [App.SocManagement]: AppType.SocManagement,
  [App.IdentityProtection]: AppType.IdentityProtection,
  [App.O365AuditLog]: AppType.O365AuditLog,
  [App.Teams]: AppType.Teams, // teams main app
  [App.TeamsBasic]: AppType.TeamsBasic, // teams second app
  [App.TeamsChat]: AppType.TeamsChat,
  [App.Mip]: AppType.Mip,
  [App.ExchangeServer]: AppType.ExchangeServer,
  [App.ExchangeMailFlow]: AppType.ExchangeMailFlow, // deprecated
  [App.ExchangeInline]: AppType.ExchangeInline, // exchange inline mail app
  [App.ExchangeInlineMailFlow]: AppType.ExchangeInlineMailFlow, // exchange inline second app
  [App.GraphNotification]: AppType.GraphNotification, // only used for special users to send notification
};

export const AppType2App: { [key in AppType]: App } = {
  [AppType.Exchange]: App.Exchange,
  [AppType.DeprecatedSharePointOneDrive]: App.DeprecatedSharePointOneDrive,
  [AppType.Box]: App.Box,
  [AppType.Dropbox]: App.Dropbox,
  [AppType.GoogleDrive]: App.GoogleDrive,
  [AppType.Rms]: App.Rms,
  [AppType.SalesforceSandbox]: App.SalesforceSandbox, // deprecated
  [AppType.SalesforceProduction]: App.SalesforceProduction, // deprecated
  [AppType.AnomalyDetection]: App.AnomalyDetection, // deprecated
  [AppType.SharePoint]: App.SharePoint, // sharepoint main app
  [AppType.SharePointBasic]: App.SharePointBasic, // sharepoint second app, used for sharepoint basic token
  [AppType.OneDrive]: App.OneDrive, // onedrive main app
  [AppType.OneDriveBasic]: App.OneDriveBasic, // onedrive second app, used for onedrive basic token
  [AppType.Gmail]: App.Gmail,
  [AppType.GmailInline]: App.GmailInline,
  [AppType.Mitigation]: App.Mitigation,
  [AppType.Soc]: App.Soc,
  [AppType.SocManagement]: App.SocManagement,
  [AppType.IdentityProtection]: App.IdentityProtection,
  [AppType.O365AuditLog]: App.O365AuditLog,
  [AppType.Teams]: App.Teams, // teams main app
  [AppType.TeamsBasic]: App.TeamsBasic, // teams second app
  [AppType.TeamsChat]: App.TeamsChat,
  [AppType.Mip]: App.Mip,
  [AppType.ExchangeServer]: App.ExchangeServer,
  [AppType.ExchangeMailFlow]: App.ExchangeMailFlow, // deprecated
  [AppType.ExchangeInline]: App.ExchangeInline, // exchange inline mail app
  [AppType.ExchangeInlineMailFlow]: App.ExchangeInlineMailFlow, // exchange inline second app
  [AppType.GraphNotification]: App.GraphNotification, // only used for special users to send notification
};

export enum AppOwnerType {
  Trend = 0,
  User = 1,
}

// Office 365 apps that in token mode, current only deprecated sharepoint and deprecated onedrive use non-token mode
export const CasO365TokenApps = [
  App.Exchange,
  App.SharePoint, // sharepoint main app
  App.SharePointBasic, // sharepoint second app, used for sharepoint basic token
  App.OneDrive, // onedrive main app
  App.OneDriveBasic, // onedrive second app, used for onedrive basic token
  App.AnomalyDetection,
  App.Rms, //deprecated
  App.Mitigation,
  App.Soc,
  App.SocManagement,
  App.IdentityProtection,
  App.O365AuditLog,
  App.Teams, // teams main app
  App.TeamsBasic, // teams second app
  App.TeamsChat,
  App.Mip,
  App.ExchangeMailFlow,
  App.ExchangeInline,
  App.ExchangeInlineMailFlow,
  App.GraphNotification,
];

export const CasOffice365Apps = [
  App.DeprecatedSharePointOneDrive,
  App.ExchangeServer,
  ...CasO365TokenApps,
];

// storage apps that in token mode
export const CasStorageApps = [
  App.Box,
  App.Dropbox,
  App.GoogleDrive,
  App.SalesforceSandbox,
  App.SalesforceProduction,
];

// gmail apps that in token mode
export const CasGmailApps = [App.Gmail, App.GmailInline];

// Apps need to migration
export const AppsNeedMigration = [App.DeprecatedSharePointOneDrive];

export const PrimaryAppsNeedMigrationProvisionMethod = [
  App.Teams,
  App.SharePoint,
  App.OneDrive,
];

/***********************************************************************************************************************
 * Apps that grouped by license
 ***********************************************************************************************************************
 */
// Apps that has CAS normal license
export const CasLicenseApps = [
  App.Exchange,
  App.Box,
  App.Dropbox,
  App.GoogleDrive,
  App.DeprecatedSharePointOneDrive, //deprecated
  App.Rms, //deprecated
  App.AnomalyDetection, // deprecated
  App.SharePoint, // sharepoint main app
  App.SharePointBasic, // sharepoint second app, used for sharepoint basic token
  App.OneDrive, // onedrive main app
  App.OneDriveBasic, // onedrive second app, used for onedrive basic token
  App.Gmail,
  App.GmailInline,
  App.Mitigation,
  App.Soc,
  App.SocManagement,
  App.IdentityProtection,
  App.Teams, // teams main app
  App.TeamsBasic, // teams second app
  App.TeamsChat,
  App.Mip,
  App.ExchangeServer, // hybrid smex
  App.ExchangeMailFlow, // deprecated
  App.ExchangeInline, // exchange inline mail app
  App.ExchangeInlineMailFlow, // exchange inline second app
  App.GraphNotification,
];

// Email addon license(Note: those apps should have CasLicenses firstly, then have CasEmailAddonApps)
export const CasEmailAddonApps = [
  App.GmailInline,
  App.ExchangeInline,
  App.ExchangeInlineMailFlow,
];

// Xdr addon license(Note: those apps should have CasLicenses firstly, then have CasXdrAddonApps)
export const CasXdrAddonApps = [App.Soc, App.SocManagement];

// Apps that has CAS salesforce license
export const SalesforceLicenseApps = [
  App.SalesforceSandbox,
  App.SalesforceProduction,
];

/***********************************************************************************************************************
 * App Token Types(tm_o365_access_token_info && tm_cloud_token & tm_rms_key)
 ***********************************************************************************************************************
 */
export enum AppTokenType {
  MailGraphApi = 1, //"azuread_graph_ex"= 1,
  SharePointGraphApi = 2, //"azuread_graph_sp"= 2,
  OneDriveGraphApi = 3, //"azuread_graph_od"= 3,
  Box = 4,
  Dropbox = 5,
  GoogleDrive = 6,
  SalesforceSandbox = 9, // deprecated
  SalesforceProduction = 10, // deprecated
  MailEWSApi = 11, // @Deprecated, "azuread_ews"= 11
  AnomalyManagement = 12, // @Deprecated: "office365_anomaly_management_api"= 12,
  TeamsSharePointOnline = 13, // @Deprecated: "csom_teams"= 13, or "azuread_sharepoint"= 13
  SpAdminSharePointOnline = 14, // @Deprecated: "csom_sharepoint_admin"= 14,
  SpBasicSharePointOnline = 15, // @Deprecated: "csom_sharepoint"= 15,
  OdBasicSharepointOnline = 16, // @Deprecated: "csom_onedrive_basic"= 16,
  SpGraphBasicApi = 17, // azuread_graph_basic_sp
  OdGraphBasicApi = 18, // azuread_graph_basic_od
  Gmail = 21,
  GmailInline = 22,
  MitigationGraphApi = 31, //"mitigation_api"= 31,
  SocGraphApi = 32, //"soc_graph_api"= 32,
  SocManagementApi = 33, //"soc_management_api"= 33,
  IdentityProtection = 35, //"microsoft_identity_protection_api"= 35,
  O365AuditLogGraphApi = 36,
  O365AuditLogManagementApi = 37,
  TeamsGraphApi = 41, //"azuread_graph_teams"= 41,
  TeamsChatGraphApi = 42, //"azuread_graph_teams_chat"= 42,
  MipGraphApi = 43, //"mip_check_license"= 43,
  MipRightManagementApi = 44, //"mip_decrypt_file"= 44,
  MipPortalApi = 45, //"mip_access_sensitivity_labels"= 45,
  MipAdminSharePointOnline = 46, //"mip_csom_apply_label"= 46,
  TeamsGraphBasicApi = 47, //"azuread_graph_basic_teams"= 47,
  ExchangeServer = 51, //"hybrid_smex"= 46,
  MailFlowExchange = 81, //deprecated, "azuread_mail_flow_ex"= 81,
  ExchangeInlineGraphApi = 82, //"azuread_mail_inline_graph_api"= 82, exchange inline mail app
  ExchangeInlineMailFlow = 83, //"azuread_mail_flow_inline_ex"= 83, exchange inline second app
  ExchangeInlineEWS = 84, //"azuread_ews_inline_ex"= 83, exchange inline second app
  NotificationGraphApi = 111, //"azuread_graph_notification"= 111, only used for special users to send notification
}

// check this link https://wiki.jarvis.trendmicro.com/display/TMCASP/Some+IDs+explanation
// Only use between UI and BFF for provision, do not use in any other place
// will be deprecated in the future
export const AppTokenType2TokenName: {
  [key in AppTokenType]: string;
} = {
  [AppTokenType.MailGraphApi]: 'azuread_graph_ex',
  [AppTokenType.SharePointGraphApi]: 'azuread_graph_sp',
  [AppTokenType.OneDriveGraphApi]: 'azuread_graph_od',
  [AppTokenType.Box]: 'box',
  [AppTokenType.Dropbox]: 'dropbox',
  [AppTokenType.GoogleDrive]: 'googledrive',
  [AppTokenType.SalesforceSandbox]: 'salesforce_sandbox', // deprecated
  [AppTokenType.SalesforceProduction]: 'salesforce_production', // deprecated
  [AppTokenType.MailEWSApi]: 'azuread_ews', //deprecated,
  [AppTokenType.AnomalyManagement]: 'office365_anomaly_management_api', //deprecated,
  [AppTokenType.SpGraphBasicApi]: 'azuread_graph_basic_sp',
  [AppTokenType.OdGraphBasicApi]: 'azuread_graph_basic_od',
  [AppTokenType.Gmail]: 'gmail', //deprecated,
  [AppTokenType.GmailInline]: 'gmailInline', //deprecated,
  [AppTokenType.TeamsSharePointOnline]: 'csom_teams', // deprecated, csom_teams"= 13, or "azuread_sharepoint"= 13
  [AppTokenType.SpAdminSharePointOnline]: 'csom_sharepoint_admin', //deprecated,
  [AppTokenType.SpBasicSharePointOnline]: 'csom_sharepoint', //deprecated,
  [AppTokenType.OdBasicSharepointOnline]: 'csom_onedrive_basic', //deprecated,
  [AppTokenType.MitigationGraphApi]: 'mitigation_api',
  [AppTokenType.SocGraphApi]: 'soc_graph_api',
  [AppTokenType.SocManagementApi]: 'soc_management_api',
  [AppTokenType.IdentityProtection]: 'microsoft_identity_protection_api',
  [AppTokenType.O365AuditLogGraphApi]: 'microsoft_audit_log',
  [AppTokenType.O365AuditLogManagementApi]: 'microsoft_audit_log',
  [AppTokenType.TeamsGraphApi]: 'azuread_graph_teams',
  [AppTokenType.TeamsChatGraphApi]: 'azuread_graph_teams_chat',
  [AppTokenType.MipGraphApi]: 'mip_check_license',
  [AppTokenType.MipRightManagementApi]: 'mip_decrypt_file',
  [AppTokenType.MipPortalApi]: 'mip_access_sensitivity_labels',
  [AppTokenType.MipAdminSharePointOnline]: 'mip_csom_apply_label',
  [AppTokenType.TeamsGraphBasicApi]: 'azuread_graph_basic_teams',
  [AppTokenType.ExchangeServer]: 'exchange_server',
  [AppTokenType.MailFlowExchange]: 'azuread_mail_flow_ex', //deprecated
  [AppTokenType.ExchangeInlineGraphApi]: 'azuread_mail_inline_graph_api',
  [AppTokenType.ExchangeInlineMailFlow]: 'azuread_mail_flow_inline_ex',
  [AppTokenType.ExchangeInlineEWS]: 'azuread_mail_inline_graph_api', // keep this to due to exchange inline app has 2 tokens
  [AppTokenType.NotificationGraphApi]: 'azuread_graph_notification', //only used for special users to send notification
};

// mark deprecated app token types
export const DeprecatedAppTokenTypes: AppTokenType[] = [
  AppTokenType.TeamsSharePointOnline, // teams
  AppTokenType.SpAdminSharePointOnline, // sharepoint
  AppTokenType.SpBasicSharePointOnline, // sharepoint
  AppTokenType.OdBasicSharepointOnline, // onedrive
];

export interface AppInfo {
  tokens: AppTokenType[];
  deprecated?: boolean; // 标记整个app是否deprecated
  isMultiTokens?: boolean; // 标记是否有多个token，默认为false
}

// office 365 apps that in token mode
// 按从小到大的顺序，最后一个是 provision 过程中最后生成的 token
export const App2AppTokenTypes: {
  [key in App]: AppInfo;
} = {
  [App.Exchange]: {
    tokens: [AppTokenType.MailGraphApi],
  },
  [App.SharePoint]: {
    tokens: [
      AppTokenType.SharePointGraphApi,
      AppTokenType.SpAdminSharePointOnline, // deprecated
      AppTokenType.SpBasicSharePointOnline, // deprecated
    ],
    isMultiTokens: true,
  },
  [App.SharePointBasic]: {
    tokens: [AppTokenType.SpGraphBasicApi],
  },
  [App.OneDrive]: {
    tokens: [
      AppTokenType.OneDriveGraphApi,
      AppTokenType.OdBasicSharepointOnline, // deprecated
    ],
    isMultiTokens: true,
  },
  [App.OneDriveBasic]: {
    tokens: [AppTokenType.OdGraphBasicApi],
  },
  [App.DeprecatedSharePointOneDrive]: {
    tokens: [],
    deprecated: true,
  },
  [App.Box]: {
    tokens: [AppTokenType.Box],
  },
  [App.Dropbox]: {
    tokens: [AppTokenType.Dropbox],
  },
  [App.GoogleDrive]: {
    tokens: [AppTokenType.GoogleDrive],
  },
  [App.Rms]: {
    tokens: [AppTokenType.MipRightManagementApi],
    deprecated: true,
  },
  [App.SalesforceSandbox]: {
    tokens: [AppTokenType.SalesforceSandbox], // deprecated
    deprecated: true,
  },
  [App.SalesforceProduction]: {
    tokens: [AppTokenType.SalesforceProduction], // deprecated
    deprecated: true,
  },
  [App.AnomalyDetection]: {
    tokens: [AppTokenType.AnomalyManagement], // deprecated
    deprecated: true,
  },
  [App.Gmail]: {
    tokens: [AppTokenType.Gmail],
  },
  [App.GmailInline]: {
    tokens: [AppTokenType.GmailInline],
  },
  [App.Mitigation]: {
    tokens: [AppTokenType.MitigationGraphApi],
  },
  [App.Soc]: {
    tokens: [AppTokenType.SocGraphApi],
  },
  [App.SocManagement]: {
    tokens: [AppTokenType.SocManagementApi],
  },
  [App.O365AuditLog]: {
    tokens: [
      AppTokenType.O365AuditLogGraphApi,
      AppTokenType.O365AuditLogManagementApi,
    ],
    isMultiTokens: true,
  },
  [App.Teams]: {
    tokens: [
      AppTokenType.TeamsGraphApi,
      AppTokenType.TeamsSharePointOnline, // deprecated
    ],
    isMultiTokens: true,
  },
  [App.TeamsBasic]: {
    tokens: [AppTokenType.TeamsGraphBasicApi],
  },
  [App.TeamsChat]: {
    tokens: [AppTokenType.TeamsChatGraphApi],
  },
  [App.Mip]: {
    tokens: [
      AppTokenType.MipGraphApi,
      AppTokenType.MipRightManagementApi,
      AppTokenType.MipPortalApi,
      AppTokenType.MipAdminSharePointOnline,
    ],
    isMultiTokens: true,
  },
  [App.IdentityProtection]: {
    tokens: [AppTokenType.IdentityProtection],
  },
  [App.ExchangeServer]: {
    tokens: [AppTokenType.ExchangeServer],
  },
  [App.ExchangeMailFlow]: {
    tokens: [AppTokenType.MailFlowExchange], // deprecated
    deprecated: true,
  },
  [App.ExchangeInline]: {
    tokens: [
      AppTokenType.ExchangeInlineEWS,
      AppTokenType.ExchangeInlineGraphApi,
    ],
    isMultiTokens: true,
  },
  [App.ExchangeInlineMailFlow]: {
    tokens: [AppTokenType.ExchangeInlineMailFlow],
  },
  [App.GraphNotification]: {
    tokens: [AppTokenType.NotificationGraphApi],
  },
};

export const AppTokenType2App: {
  [key in AppTokenType]: App;
} = {
  [AppTokenType.MailGraphApi]: App.Exchange,
  [AppTokenType.SharePointGraphApi]: App.SharePoint,
  [AppTokenType.OneDriveGraphApi]: App.OneDrive,
  [AppTokenType.Box]: App.Box,
  [AppTokenType.Dropbox]: App.Dropbox,
  [AppTokenType.GoogleDrive]: App.GoogleDrive,
  [AppTokenType.SalesforceSandbox]: App.SalesforceSandbox, // deprecated
  [AppTokenType.SalesforceProduction]: App.SalesforceProduction, // deprecated
  [AppTokenType.MailEWSApi]: App.Exchange, // deprecated, EWS Exchange
  [AppTokenType.AnomalyManagement]: App.AnomalyDetection,
  [AppTokenType.SpAdminSharePointOnline]: App.SharePoint, // deprecated,
  [AppTokenType.SpBasicSharePointOnline]: App.SharePoint, // deprecated,
  [AppTokenType.OdBasicSharepointOnline]: App.OneDrive, // deprecated,
  [AppTokenType.SpGraphBasicApi]: App.SharePoint, // new token mode
  [AppTokenType.OdGraphBasicApi]: App.OneDrive, // new token mode
  [AppTokenType.Gmail]: App.Gmail,
  [AppTokenType.GmailInline]: App.GmailInline,
  [AppTokenType.MitigationGraphApi]: App.Mitigation,
  [AppTokenType.SocGraphApi]: App.Soc,
  [AppTokenType.SocManagementApi]: App.SocManagement,
  [AppTokenType.IdentityProtection]: App.IdentityProtection,
  [AppTokenType.O365AuditLogGraphApi]: App.O365AuditLog,
  [AppTokenType.O365AuditLogManagementApi]: App.O365AuditLog,
  [AppTokenType.TeamsGraphApi]: App.Teams, // teams main app
  [AppTokenType.TeamsSharePointOnline]: App.Teams, // deprecated, csom_teams or azuread_sharepoint
  [AppTokenType.TeamsChatGraphApi]: App.TeamsChat,
  [AppTokenType.MipGraphApi]: App.Mip,
  [AppTokenType.MipRightManagementApi]: App.Mip,
  [AppTokenType.MipPortalApi]: App.Mip,
  [AppTokenType.MipAdminSharePointOnline]: App.Mip,
  [AppTokenType.TeamsGraphBasicApi]: App.TeamsBasic, // new token mode, teams second app
  [AppTokenType.ExchangeServer]: App.ExchangeServer,
  [AppTokenType.MailFlowExchange]: App.ExchangeMailFlow, // deprecated
  [AppTokenType.ExchangeInlineGraphApi]: App.ExchangeInline, // exchange inline mail app
  [AppTokenType.ExchangeInlineMailFlow]: App.ExchangeInlineMailFlow, // exchange inline mail app
  [AppTokenType.ExchangeInlineEWS]: App.ExchangeInline, // exchange inline mail app
  [AppTokenType.NotificationGraphApi]: App.GraphNotification, // only used for special users to send notification
};

// /***********************************************************************************************************************
//  * Cloud App Type(cloud_app_info): Apps for all integrated 3rd party services
//  ***********************************************************************************************************************
//  */
export enum CloudAppType {
  Exchange = 1,
  SharePoint = 2, // new token mode
  OneDrive = 3, // new token mode
  Box = 4,
  Dropbox = 5,
  GoogleDrive = 6,
  SalesforceSandbox = 9, // deprecated
  SalesforceProduction = 10, // deprecated
  // MailEWSApi = 11, // deprecated
  AnomalyDetection = 12, // deprecated
  // TeamsSharePointOnline = 13, //"csom_teams"= 13, or "azuread_sharepoint"= 13, deprecated
  // SpAdminSharePointOnline = 14, //"csom_sharepoint_admin"= 14, deprecated
  // SpBasicSharePointOnline = 15, //"csom_sharepoint"= 15, deprecated
  // OdBasicSharepointOnline = 16, //"csom_onedrive_basic"= 16, deprecated
  SharePointBasic = 17, // azuread_graph_basic_sp, sharepoint second app, used for sharepoint basic token
  OneDriveBasic = 18, // azuread_graph_basic_od, // onedrive second app, used for onedrive basic token
  Gmail = 21,
  GmailInline = 22,
  Mitigation = 31, //"mitigation_api"= 31,
  Soc = 32, //"soc_graph_api"= 32,
  SocManagement = 33, //"soc_management_api"= 33,
  IdentityProtection = 35, //"microsoft_identity_protection_api"= 35,
  Teams = 41, //"azuread_graph_teams"= 41,
  TeamsChat = 42, //"azuread_graph_teams_chat"= 42,
  Mip = 43, //"mip_check_license"= 43,
  TeamsBasic = 47, // teams second app, "azuread_graph_basic_teams"= 47,
  // MipRightManagementApi = 44, //"mip_decrypt_file"= 44, deprecated
  // MipPortalApi = 45, //"mip_access_sensitivity_labels"= 45, deprecated
  // MipAdminSharePointOnline = 46, //"mip_csom_apply_label"= 46, deprecated
  ExchangeMailFlow = 81, //deprecated, "azuread_mail_flow_ex"= 81,
  ExchangeInline = 82, //"azuread_mail_inline_graph_api"= 82, exchange inline main app
  ExchangeInlineMailFlow = 83, //"azuread_mail_flow_inline_ex"= 83, exchange inline second app
  // ExchangeInlineEWS = 84, //"azuread_mail_flow_inline_ex"= 83, exchange inline second app
  GraphNotification = 111, //"azuread_grapah_notification“
  AssessmentSingleUser = 512, //assessment exchange single user
}

export const App2CloudAppType: {
  [key in App[number]]: CloudAppType;
} = {
  [App.Exchange]: CloudAppType.Exchange,
  [App.SharePoint]: CloudAppType.SharePoint,
  [App.OneDrive]: CloudAppType.OneDrive,
  [App.Box]: CloudAppType.Box,
  [App.Dropbox]: CloudAppType.Dropbox,
  [App.GoogleDrive]: CloudAppType.GoogleDrive,
  [App.SalesforceSandbox]: CloudAppType.SalesforceSandbox, // deprecated
  [App.SalesforceProduction]: CloudAppType.SalesforceProduction, // deprecated
  [App.AnomalyDetection]: CloudAppType.AnomalyDetection, // deprecated
  [App.SharePointBasic]: CloudAppType.SharePointBasic, // sharepoint second app, used for sharepoint basic token
  [App.OneDriveBasic]: CloudAppType.OneDriveBasic, // onedrive second app, used for onedrive basic token
  [App.Gmail]: CloudAppType.Gmail,
  [App.GmailInline]: CloudAppType.GmailInline,
  [App.Mitigation]: CloudAppType.Mitigation,
  [App.Soc]: CloudAppType.Soc,
  [App.SocManagement]: CloudAppType.SocManagement,
  [App.IdentityProtection]: CloudAppType.IdentityProtection,
  [App.Teams]: CloudAppType.Teams, // teams main app
  [App.TeamsBasic]: CloudAppType.TeamsBasic, // teams second app
  [App.TeamsChat]: CloudAppType.TeamsChat,
  [App.Mip]: CloudAppType.Mip,
  [App.ExchangeMailFlow]: CloudAppType.ExchangeMailFlow, // deprecated
  [App.ExchangeInline]: CloudAppType.ExchangeInline, // exchange inline mail app
  [App.ExchangeInlineMailFlow]: CloudAppType.ExchangeInlineMailFlow, // exchange inline second app
  [App.GraphNotification]: CloudAppType.GraphNotification, // only used for special users to send notification
};

/***********************************************************************************************************************
 * App and Services
 ***********************************************************************************************************************
 */
// apps that have policy(is equal to service)
export const App2Service: {
  [key: App[number]]: Service;
} = {
  [App.Exchange]: Service.Exchange,
  [App.DeprecatedSharePointOneDrive]: Service.SharePoint, // deprecated
  [App.SharePoint]: Service.SharePoint,
  [App.OneDrive]: Service.OneDrive,
  [App.Box]: Service.Box,
  [App.Dropbox]: Service.Dropbox,
  [App.GoogleDrive]: Service.GoogleDrive,
  [App.SalesforceSandbox]: Service.SalesforceSandbox, // deprecated
  [App.SalesforceProduction]: Service.SalesforceProduction, // deprecated
  [App.SharePointBasic]: Service.SharePoint, // sharepoint second app, used for sharepoint basic token
  [App.OneDriveBasic]: Service.OneDrive, // onedrive second app, used
  [App.Gmail]: Service.Gmail,
  [App.GmailInline]: Service.GmailInline,
  [App.Teams]: Service.Teams, // teams main app
  [App.TeamsBasic]: Service.Teams, // teams second app
  [App.TeamsChat]: Service.TeamsChat,
  [App.ExchangeInline]: Service.ExchangeInline,
  [App.ExchangeInlineMailFlow]: Service.ExchangeInline,
  [App.ExchangeServer]: Service.ExchangeServer,
  [App.Mip]: Service.Mip,
  [App.IdentityProtection]: Service.IdentityProtection,
};

/***********************************************************************************************************************
 * For Storage Apps may need app name to query database
 ***********************************************************************************************************************
 */
export const App2StorageProvisionApp: { [key: App[number]]: string } = {
  [App.Box]: 'box',
  [App.Dropbox]: 'dropbox',
  [App.GoogleDrive]: 'googledrive',
  [App.SalesforceProduction]: 'salesforce_production', // deprecated
  [App.SalesforceSandbox]: 'salesforce_sandbox', // deprecated
};

export const StorageProvisionApp2App: { [key: string]: App } = {
  box: App.Box,
  dropbox: App.Dropbox,
  googledrive: App.GoogleDrive,
  salesforce_production: App.SalesforceProduction, // deprecated
  salesforce_sandbox: App.SalesforceSandbox, // deprecated
};
/***********************************************************************************************************************
 * For CAS Login Account Type
 ***********************************************************************************************************************
 */
export enum CasAccountType {
  ClpAccount = 'CLPAccount',
  LoginAccount = 'LoginAccount',
  ApiAccount = 'ApiAccount',
  None = 'None',
}

/***********************************************************************************************************************
 * For CAS Audit Log
 ***********************************************************************************************************************
 */
export enum AuditLogType {
  Policy = 'policy',
  Provision = 'provision',
  DlpTemplate = 'template',
  DlpExpression = 'expression',
  DlpKeyword = 'keyword',
  EmailReporting = 'emailReporting',
}

export enum AuditLogStatus {
  Success = 'success',
  Failure = 'failure',
}

export enum AuditLogAction {
  Enable = 'enable',
  Disable = 'disable',
  Add = 'add',
  Update = 'update',
  Delete = 'delete',
  Copy = 'copy',
  ReOrder = 'reorder',
}

// keep filter field name same with tm_policy
const AuditLogPolicy = {
  [AuditLogAction.Add]: 'add',
  [AuditLogAction.Update]: 'update',
  [AuditLogAction.Delete]: 'delete',
  [AuditLogAction.Copy]: 'copy',
  [AuditLogAction.ReOrder]: 'reorder',
  [AuditLogAction.Enable]: 'enable',
  [AuditLogAction.Disable]: 'disable',
  tmAntispamfilters: {
    asEnabled: {
      [AuditLogAction.Enable]: 'enableAdvancedSpamProtection',
      [AuditLogAction.Disable]: 'disableAdvancedSpamProtection',
    },
    asApprovedSenderEmailEnabled: {
      [AuditLogAction.Enable]: 'enableAdvancedSpamProtectionApprovedSender',
      [AuditLogAction.Disable]: 'disableAdvancedSpamProtectionApprovedSender',
    },
    asApprovedSenderEmailEntries: {
      [AuditLogAction.Update]:
        'updateAdvancedSpamProtectionApprovedSenderEmailEntries',
    },
    asBlockedSenderEmailEnabled: {
      [AuditLogAction.Enable]: 'enableAdvancedSpamProtectionBlockSender',
      [AuditLogAction.Disable]: 'disableAdvancedSpamProtectionBlockSender',
    },
    asBlockedSenderEmailEntries: {
      [AuditLogAction.Update]:
        'updateAdvancedSpamProtectionBlockedSenderEmailEntries',
    },
    asApprovedHeaderEnabled: {
      [AuditLogAction.Enable]:
        'enableAdvancedSpamProtectionApprovedHeaderField',
      [AuditLogAction.Disable]:
        'disableAdvancedSpamProtectionApprovedHeaderField',
    },
    asApprovedHeaderList: {
      [AuditLogAction.Update]: 'updateAdvancedSpamProtectionApprovedHeaderList',
    },
    asBlockedHeaderEnabled: {
      [AuditLogAction.Enable]: 'enableAdvancedSpamProtectionBlockedHeaderField',
      [AuditLogAction.Disable]:
        'disbleAdvancedSpamProtectionBlockedHeaderField',
    },
    asBlockedHeaderRuleList: {
      [AuditLogAction.Update]:
        'updateAdvancedSpamProtectionBlockedHeaderRuleList',
    },
    asSpamLevel: {
      [AuditLogAction.Update]: 'updateAdvancedSpamProtectionDetectionLevel',
    },
    asApplyBound: {
      [AuditLogAction.Update]: 'updateAdvancedSpamProtectionApplyTo',
    },
  },
  tmVirusscans: {
    vsApplyBound: {
      [AuditLogAction.Update]: 'updateMalwareScanningApplyTo',
    },
    vsDisarmExceptSenderString: {
      [AuditLogAction.Update]: 'updateMalwareScanningDisarmExceptSenderString',
    },
    vsDisarmExceptReceiverString: {
      [AuditLogAction.Update]:
        'updateMalwareScanningDisarmExceptReceiverString',
    },
  },
  tmFileblockings: {
    fbEnabled: {
      [AuditLogAction.Enable]: 'enableFileBlocking',
      [AuditLogAction.Disable]: 'disableFileBlocking',
    },
    fbApprovedSenderEmailEntries: {
      [AuditLogAction.Update]: 'updateFileBlockingApprovedSenderEmailEntries',
    },
    fbApplyBound: {
      [AuditLogAction.Update]: 'updateFileBlockingApplyTo',
    },
  },
  tmDpfilters: {
    dpEnabled: {
      [AuditLogAction.Enable]: 'enableDataLossPrevention',
      [AuditLogAction.Disable]: 'disableDataLossPrevention',
    },
  },
  tmWebthreatprotections: {
    wtpEnabled: {
      [AuditLogAction.Enable]: 'enableWebReputation',
      [AuditLogAction.Disable]: 'disableWebReputation',
    },
    wtpApprovedSenderEmailEnabled: {
      [AuditLogAction.Enable]: 'enableWebReputationApprovedSender',
      [AuditLogAction.Disable]: 'disableWebReputationApprovedSender',
    },
    wtpApprovedSenderEmailEntries: {
      [AuditLogAction.Update]: 'updateWebReputationApprovedSenderEmailEntries',
    },
    wtpApprovedUrlListEnabled: {
      [AuditLogAction.Enable]: 'enableWebReputationApprovedUrlList',
      [AuditLogAction.Disable]: 'disableWebReputationApprovedUrlList',
    },
    wtpApprovedUrlListEntries: {
      [AuditLogAction.Update]: 'updateWebReputationApprovedUrlListEntries',
    },
    wtpBlockedUrlListEnabled: {
      [AuditLogAction.Enable]: 'enableWebReputationBlockUrlList',
      [AuditLogAction.Disable]: 'disableWebReputationBlockUrlList',
    },
    wtpBlockedUrlListEntries: {
      [AuditLogAction.Update]: 'updateWebReputationBlockedUrlListEntries',
    },
    wtpApprovedHeaderEnabled: {
      [AuditLogAction.Enable]: 'enableWebReputationApprovedHeaderField',
      [AuditLogAction.Disable]: 'disableWebReputationApprovedHeaderField',
    },
    wtpApprovedHeaderList: {
      [AuditLogAction.Update]: 'updateWebReputationApprovedHeaderList',
    },
    wtpTocApprovedUrlListEntries: {
      [AuditLogAction.Update]: 'updateWebReputationTocApprovedUrlListEntries',
    },
    wtpApplyBound: {
      [AuditLogAction.Update]: 'updateWebReputationApplyTo',
    },
  },
  tmDdafilters: {
    ddaEnabled: {
      [AuditLogAction.Enable]: 'enableVirtualAnalyzer',
      [AuditLogAction.Disable]: 'disableVirtualAnalyzer',
    },
    ddaApprovedSenderEmailEnabled: {
      [AuditLogAction.Enable]: 'enableVirtualAnalyzerApprovedSender',
      [AuditLogAction.Disable]: 'disableVirtualAnalyzerApprovedSender',
    },
    ddaApprovedSenderEmailEntries: {
      [AuditLogAction.Update]:
        'updateVirtualAnalyzerApprovedSenderEmailEntries',
    },
    ddaApprovedFileNameEnabled: {
      [AuditLogAction.Enable]: 'enableVirtualAnalyzerApprovedFileName',
      [AuditLogAction.Disable]: 'disableVirtualAnalyzerApprovedFileName',
    },
    ddaApprovedFileNameEntries: {
      [AuditLogAction.Update]: 'updateVirtualAnalyzerApprovedFileNameEntries',
    },
    ddaApplyBound: {
      [AuditLogAction.Update]: 'updateVirtualAnalyzerApplyTo',
    },
  },
  tmKeywordfilters: {
    kfEnabled: {
      [AuditLogAction.Enable]: 'enableDataLossPreventionKeywordExtraction',
      [AuditLogAction.Disable]: 'disableDataLossPreventionKeywordExtraction',
    },
  },
  tmSlfFilters: {
    slfEnabled: {
      [AuditLogAction.Enable]: 'enableShareLink',
      [AuditLogAction.Disable]: 'disableShareLink',
    },
    slfExceptionList: {
      [AuditLogAction.Update]: 'updateShareLinkExceptionList',
    },
  },
  tmRiskAiFilters: {
    raiEnabled: {
      [AuditLogAction.Enable]: 'enableCorrelatedIntelligence',
      [AuditLogAction.Disable]: 'disableCorrelatedIntelligence',
    },
    raiAgenticAiEnabled: {
      [AuditLogAction.Enable]: 'enableCorrelatedIntelligenceAgenticAi',
      [AuditLogAction.Disable]: 'disableCorrelatedIntelligenceAgenticAi',
    },
    raiApprovedSenderEmailEnabled: {
      [AuditLogAction.Enable]: 'enableCorrelatedIntelligenceApprovedList',
      [AuditLogAction.Disable]: 'disableCorrelatedIntelligenceApprovedList',
    },
    raiApprovedSenderEmailEntries: {
      [AuditLogAction.Update]: 'updateCorrelatedIntelligenceApprovedList',
    },
    tmRaiFilterRules: {
      [AuditLogAction.Update]: 'updateCorrelatedIntelligenceAnomaliesRules',
    },
    raiAnomalyExpRules: {
      [AuditLogAction.Update]: 'updateCorrelatedIntelligenceAnomaliesExpRules',
    },
  },
  otherPolicyDetails: {
    [AuditLogAction.Update]: 'updateOtherPolicyDetails',
  },
};

const AuditLogDlpTemplate: { [key: string]: any } = {
  [AuditLogAction.Add]: 'add',
  [AuditLogAction.Update]: 'update',
  [AuditLogAction.Copy]: 'copy',
  [AuditLogAction.Delete]: 'delete',
};

const AuditLogDlpKeyword: { [key: string]: any } = {
  [AuditLogAction.Add]: 'add',
  [AuditLogAction.Update]: 'update',
  [AuditLogAction.Copy]: 'copy',
  [AuditLogAction.Delete]: 'delete',
};

const AuditLogDlpExpression: { [key: string]: any } = {
  [AuditLogAction.Add]: 'add',
  [AuditLogAction.Update]: 'update',
  [AuditLogAction.Copy]: 'copy',
  [AuditLogAction.Delete]: 'delete',
};

export const AuditLog = {
  [AuditLogType.Policy]: AuditLogPolicy,
  [AuditLogType.DlpTemplate]: AuditLogDlpTemplate,
  [AuditLogType.DlpKeyword]: AuditLogDlpKeyword,
  [AuditLogType.DlpExpression]: AuditLogDlpExpression,
};

export enum AdvancedFeatureTypeEnum {
  enableUrlSandbox = 'enableUrlSandbox',
  provision = 'provision',
}

export interface AdvancedFeatureInfo {
  needConfirm: boolean;
  avaliableCreit?: number;
  aadUserCount?: number;
}

export enum IdpNameToType {
  'AzureADOrAdfs' = 1,
  Okta = 2,
  Google = 3,
  PingOne = 4,
}

export const IdpTypeToName: { [key in IdpNameToType]: string } = {
  [IdpNameToType.AzureADOrAdfs]: 'AzureADOrAdfs',
  [IdpNameToType.Okta]: 'Okta',
  [IdpNameToType.Google]: 'Google',
  [IdpNameToType.PingOne]: 'PingOne',
};
